import SharedBloks from '@webcarelbj/shared-bloks'

export default defineNuxtPlugin({
  name: 'shared-bloks',
  dependsOn: ['shared-components'],
  setup({ vueApp }) {
    const tracking = useTracking()
    const store = useGaTrackingStore()
    const { pageTrackingData }  = storeToRefs(store)

    vueApp.use(SharedBloks, {
      richText: { assetDomainReplace: 'assets.pflege.de' },
      downloadBtn: { downloadDomainReplace: 'assets.pflege.de' },
      tracking: {
        createTrackingLabel: tracking.createTrackingLabel,
        prepareClickContext: (component, mainComponentLabel, label) => {
          tracking.trackClick(component, mainComponentLabel, label, pageTrackingData.value)
        },
        trackVideo: (data) => {
          tracking.trackVideo({ ...pageTrackingData.value, ...data })
        },
        trackView: (data) => {
          tracking.trackView({ ...pageTrackingData.value, ...data })
        },
      },
    })
  },
})
